$(document).ready(function(){
   $('.announcement-first-top').on('click', function(){
     const _this = $(this);
      _this.toggleClass('active');
     $('.announcement-bar').toggleClass('z-index')
     $('.announcement-first-bottom').slideToggle();
   });

  $(".box-menu-bottom .newsletter a").on("click", function (e) {
        e.preventDefault();
        let target = $(this).attr("href");
        $('.icon-close-custom').trigger('click');
        $("html, body").animate(
            {
                scrollTop: $(target).offset().top - 50,
            },
            1000
        );
    });
})
